<div class="msin-background"></div>

<mat-card appearance="outlined" class="login-page">
	<mat-card-header>
		<mat-card-title>
			<a routerLink="/login">
				<img class="login-logo" alt="MSIN Logo"
					src="../../../../assets/images/MSIN-Logo_Color-White-Text.png" />
			</a>
		</mat-card-title>
	</mat-card-header>
	<mat-card-content>
		<mat-card appearance="outlined">
			<mat-card-header>
				<mat-card-title>Forgot Username</mat-card-title>
				<mat-card-subtitle>
					Please enter your email address to have your username sent to
					you.
				</mat-card-subtitle>
			</mat-card-header>
			<mat-card-content>
				<form [formGroup]="form" class="column">
					<mat-form-field style="width:100%;">
						<mat-label>Email</mat-label>
						<input matInput type="email" placeholder="Email" formControlName="email" />
					</mat-form-field>

					<!-- <app-recaptcha [form]="form"></app-recaptcha> -->

					<button class="w-100" mat-raised-button color="primary" (click)="submit()"
						[disabled]="!form.valid || isLoading">
						<mat-icon *ngIf="isLoading">
							<mat-spinner diameter="20"> </mat-spinner>
						</mat-icon>
						Submit
					</button>

					<app-msg [msg]="msg"></app-msg>
				</form>
			</mat-card-content>
		</mat-card>
		<mat-card appearance="outlined" class="margin-top-sm">
			<a mat-raised-button routerLink="/login">Back to Login</a>
		</mat-card>
	</mat-card-content>
</mat-card>